import { graphql } from "gatsby";
import React from "react";
import useRepairabilityIndexImg from "../hooks/use-repairability-index";
import classNames from "classnames";

const RepairabilityIndex = ({ data, lineId }) => {
  const indexUrl = useRepairabilityIndexImg(data.indexValue, lineId);
  const isDurability = indexUrl?.includes("durability");

  return indexUrl ? (
    <a
      href={data.pdfDocument.node.publicURL}
      target="_blank"
      rel="noreferrer"
      className={isDurability ? "prodotti__doc-durability" : "prodotti__doc-repairability"}
    >
      <img
        src={indexUrl}
        className={classNames(isDurability ? "icon-durability" : "icon-repairability")}
        alt={data.indexValue}
      />
      <span
        className={classNames(
          isDurability ? "prodotti__doc-durability--value" : "prodotti__doc-repairability--value"
        )}
      >
        {data.indexValue}
      </span>
      <span
        className={classNames(
          isDurability ? "prodotti__doc-durability--ten" : "prodotti__doc-repairability--ten"
        )}
      >
        /10
      </span>
    </a>
  ) : null;
};

export default RepairabilityIndex;

export const fragment = graphql`
  fragment RepairabilityIndex on LiferayRepairabilityIndex {
    product {
      sku
      indexValue
      pdfDocument {
        node {
          publicURL
        }
        value {
          fileExtension
        }
      }
    }
  }
`;
